import { c as _c } from "react/compiler-runtime";
import { AspectRatio, Box, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { ListNavDotIndicator } from '@src/components/sco/Education/PodcastListNav/ListNavDotIndicator';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { SSRGate } from '@src/components/sco/utilities/SSRGate';
import React from 'react';
type PodcastListNavCardProps = {
  podcast?: any;
  id?: string;
  slug?: string;
  image?: string;
};
export const PodcastListNavCard = props => {
  const $ = _c(32);
  const educationContext = useEducationContext();
  const t0 = `/podcast/${props.slug}`;
  const t1 = educationContext.activeContent.item?.id === props.id ? "#534EEE" : "transparent";
  const t2 = educationContext.activeContent.item?.id === props.id ? "base" : "none";
  const t3 = educationContext.activeContent.item?.id === props.id ? "#534EEE" : "#18172750";
  let t4;
  if ($[0] !== t3) {
    t4 = {
      bgColor: t3
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = educationContext.activeContent.item?.id === props.id;
  let t6;
  if ($[2] !== props.id || $[3] !== props.podcast.__typename || $[4] !== t5) {
    t6 = <SSRGate disableSSR={true}><ListNavDotIndicator isActive={t5} viewableId={props.id} viewableType={props.podcast.__typename} /></SSRGate>;
    $[2] = props.id;
    $[3] = props.podcast.__typename;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== props.image) {
    t7 = <Box flex={1.5} position="relative" width="full"><AspectRatio borderRadius="sm" boxShadow="md" overflow="hidden" ratio={1} width="full"><Image src={props.image} /></AspectRatio></Box>;
    $[6] = props.image;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      color: "white"
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = educationContext.activeContent.item?.id === props.id ? "actionPrimary" : "purpleLightAlpha.500";
  let t10;
  if ($[9] !== props.podcast.number || $[10] !== t9) {
    t10 = <Text _hover={t8} as="span" opacity={0.5} textStyle="badgeXs" transition="color 0.2s ease-in" color={t9}>#{props.podcast.number}</Text>;
    $[9] = props.podcast.number;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      color: "white"
    };
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = educationContext.activeContent.item?.id === props.id ? "white" : "purpleLightAlpha.700";
  let t13;
  if ($[13] !== props.podcast.title || $[14] !== t12) {
    t13 = <Text _hover={t11} as="span" fontWeight={500} lineClamp={2} lineHeight="short" textStyle="labelXs" transition="color 0.2s ease-in" color={t12}>{props.podcast.title}</Text>;
    $[13] = props.podcast.title;
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t10 || $[17] !== t13) {
    t14 = <VStack align="flex-start" flex={4} gap={0.5}>{t10}{t13}</VStack>;
    $[16] = t10;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14 || $[20] !== t6 || $[21] !== t7) {
    t15 = <HStack align="center" gap={3} width="full">{t6}{t7}{t14}</HStack>;
    $[19] = t14;
    $[20] = t6;
    $[21] = t7;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== props.id || $[24] !== t1 || $[25] !== t15 || $[26] !== t2 || $[27] !== t4) {
    t16 = <HStack key={props.id} align="flex-start" bgColor={t1} borderRadius="md" boxShadow={t2} gap="1em" justify="flex-start" padding={2} transition="all 0.2s ease-in" width="full" _hover={t4}>{t15}</HStack>;
    $[23] = props.id;
    $[24] = t1;
    $[25] = t15;
    $[26] = t2;
    $[27] = t4;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t0 || $[30] !== t16) {
    t17 = <Box width="full"><NextLink href={t0} prefetch={false}>{t16}</NextLink></Box>;
    $[29] = t0;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
};